import { Alert, Button, Card, Heading, Stack } from "@softmax/design-system";
import { useAccountSignOut } from "./use-account-sign-out";

export function AccountSignOut() {
  const signOut = useAccountSignOut();
  return (
    <Card>
      <Stack width="auto">
        <Heading level={2}>Sign out</Heading>
        {signOut.error ? <Alert tone="danger">{signOut.error}</Alert> : null}
        <div>
          <Button
            type="button"
            size="sm"
            disabled={signOut.pending}
            onClick={signOut.onSignOut}
          >
            {signOut.pending ? "Signing out…" : "Sign out"}
          </Button>
        </div>
      </Stack>
    </Card>
  );
}
